/**
 * Stamp Events Utility
 * Centralized functions for dispatching stamp change events to navbar animation
 */

export type StampChangeReason =
  | 'belt_entry'
  | 'belt_completion'
  | 'daily_challenge'
  | 'weekly_challenge'
  | 'daily_bonus'
  | 'purchase'
  | 'refund'
  | 'game_entry'
  | 'milestone'
  | 'other';

export interface StampChangeEvent {
  amount: number;
  type: 'earn' | 'spend';
  newBalance: number;
  reason?: StampChangeReason;
}

/**
 * Dispatch a stamp earn event to trigger navbar animation
 * @param amount - Number of stamps earned (positive)
 * @param newBalance - New total stamp balance after earning
 * @param reason - Optional reason for earning stamps
 */
export const dispatchStampEarn = (
  amount: number,
  newBalance: number,
  reason?: StampChangeReason
): void => {
  if (amount <= 0) return;

  window.dispatchEvent(
    new CustomEvent<StampChangeEvent>('stamps:changed', {
      detail: {
        amount,
        type: 'earn',
        newBalance,
        reason,
      },
    })
  );
};

/**
 * Dispatch a stamp spend event to trigger navbar animation
 * @param amount - Number of stamps spent (positive)
 * @param newBalance - New total stamp balance after spending
 * @param reason - Optional reason for spending stamps
 */
export const dispatchStampSpend = (
  amount: number,
  newBalance: number,
  reason?: StampChangeReason
): void => {
  if (amount <= 0) return;

  window.dispatchEvent(
    new CustomEvent<StampChangeEvent>('stamps:changed', {
      detail: {
        amount,
        type: 'spend',
        newBalance,
        reason,
      },
    })
  );
};
